module.exports = __webpack_public_path__ + "static/companies-booked-calendars-ecd1a1c90bdaa17847aade6c2b4716f4.png";